module.exports = __webpack_public_path__ + "static/media/agc011.c844e61b.jpg";